module.exports = __webpack_public_path__ + "static/media/eye14.e96461a2.jpeg";